import React from 'react';
import { Image, Box } from '@chakra-ui/react';

interface NeurevLogoProps {
  width?: string | number;
  height?: string | number;
}

export const NeurevLogo: React.FC<NeurevLogoProps> = ({ width, height = 80 }) => {
  // Logo aspect ratio is 895:393 = 2.28:1
  const aspectRatio = 895 / 393;
  
  // Calculate dimensions maintaining aspect ratio
  const logoWidth = width || (typeof height === 'number' ? height * aspectRatio : 80 * aspectRatio);
  const logoHeight = height || (typeof width === 'number' ? width / aspectRatio : 80);
  
  return (
    <Box width={logoWidth} height={logoHeight}>
      <Image
        src="/neurev-logo.png"
        alt="NEUREV Logo"
        width="100%"
        height="100%"
        objectFit="contain"
      />
    </Box>
  );
};

// Simple version for smaller spaces
export const NeurevLogoSimple: React.FC<NeurevLogoProps> = ({ width, height = 32 }) => {
  const aspectRatio = 895 / 393;
  const logoWidth = width || (typeof height === 'number' ? height * aspectRatio : 32 * aspectRatio);
  const logoHeight = height || (typeof width === 'number' ? width / aspectRatio : 32);
  
  return (
    <Box width={logoWidth} height={logoHeight}>
      <Image
        src="/neurev-logo.png"
        alt="NEUREV"
        width="100%"
        height="100%"
        objectFit="contain"
        borderRadius="md"
      />
    </Box>
  );
};

export default NeurevLogo;
